<template>
<div>
    <nav-menu/>
    
    <b-container>
    <b-row>
        <b-col sm="12 my-2">
            <div class="d-flex justify-content-between">
                <h5>Produtos</h5>
                <b-button size="sm" @click="newProduct" variant="primary">+ Novo Produto</b-button>
            </div>
        </b-col>
    </b-row>
   
    <b-row class="my-2">
        <b-col sm="12">
            <search @search="searchItems($event)" @clean="searchItems($event)"></search>
        </b-col>
    </b-row>
    
    <BRow class="ml-1">
        <b-button-group class="sm-col-4">
                    <b-button size="sm" variant="outline-success" @click="exportTableXLXS"><b-icon icon="file-earmark-spreadsheet" tooltip="Exportar para Excel"></b-icon> Exportar Excel</b-button>                    
                    <!-- <b-button size="sm" class="bg-danger" @click="exportTablePDF"><b-icon icon="file-earmark-pdf" tooltip="Exportar para PDF"></b-icon> Exportar PDF</b-button>                     -->
        </b-button-group>
    </BRow>
    
     <BRow>
        <div class="w-100 m-2">
            <span class="font-weight-bold m-1">
                Custo Total Do Ateliêr: 
            </span>
            <span>{{ (totalVariableCosts + totalFixedCosts).toLocaleString('pt-BR', {
                 style: 'currency',
                 currency: 'BRL',
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2
            }) }}</span>
        </div>
    </BRow>

    <b-row>
        <b-col sm="12">
            <b-table small id="tableProducts" striped hover 
            :items="products.slice(currentItem,currentItem+perPage)" :fields="fields"
            @row-clicked="onRowClicked"
            >
                
                <template #cell(materialCost)="data">
                    <span class="fs-6">R$ {{ parseFloat(data.value)? parseFloat(data.value).toFixed(2) : parseFloat(0).toFixed(2) }}</span>
                </template>

                <template #cell(totalCost)="data">
                    <span class="fs-6">R$ {{ parseFloat(data.value) ? parseFloat(data.value).toFixed(2) : parseFloat(0).toFixed(2) }}</span>
                </template>
                
                <template #cell(finalPrice)="data">
                    <span class="fs-6">{{ parseFloat(data.value).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }) }}</span>
                </template>
                
                <template #cell(options)="row">
                    <option-buttons :rowItem="row.item" :rowIndex="row.index"
                        @viewItem="(item)=>viewItem(item)"
                        @copyItem="(item)=>copyItem(item)"
                        @removeItem="(item)=>delProduct(item)">
                    </option-buttons>
                </template>
            </b-table>
        </b-col>
    </b-row>
    <b-row class="my-1">
        <b-col sm="12">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex">
                    <b-form-select v-model="perPage" :options="options"></b-form-select>
                    <b-pagination
                      v-model="currentPage"
                      align="fill"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="tableProducts"
                    ></b-pagination>
                </div>
                
            </div>
        </b-col>
    </b-row>
    <product-one 
        id="productModal" 
        :title="modalTitle" 
        :variableCosts="totalVariableCosts" 
        :fixedCosts="totalFixedCosts" 
        :profit="profit" 
        :productOne="productOne"
        @newProduct="(e)=>addProduct(e)" 
        @delItem="(id)=>removeProduct(id)" 
        @cost-updated="(newCost)=>handleCostUpdated(newCost)" 
    />
    
  </b-container>

</div>
</template>

<script>
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import Search from "../components/SearchBar.vue"
import ProductOne from "../components/ProductOne.vue"
import OptionButtons from "../components/OptionButtons.vue"
import NavMenu from "@/views/NavMenu.vue"
import axios, { AxiosError } from "axios";
import logout from "@/helpers/LogoutHelper";
import Vue from 'vue'

export default {
    metaInfo:{
        title: "Produtos"
    },
    data(){
        return {
            products:[],
            productsNoFilter: [],
            fields:[
            {key:"productName", sortable:true, label:"Nome"}, 
            {key:'finalPrice', sortable:true, label:"Preço Sugerido de Venda"},
            {key:'options', label:"Ações"}],
            productOne: {
                id: null,
                productName: '',
                productionHours: 0,
                directCosts: []
            },
            currentPage:1,
            perPage:10,
            options:[10,20,50],
            totalVariableCosts:0.00,
            totalFixedCosts:0.00,
            profit: 0.00,
            modalTitle: ""
        }
    },
    methods:{
        searchItems(filter) {            
            if (filter.length > 0) {
                this.products=this.products.filter(item=>item.productName.toLowerCase().includes(filter.toLowerCase()))
            }else{
               this.products = this.productsNoFilter
            }
        },
        removeProduct(id){
            this.products.splice(this.products.findIndex(prod => prod.id === id), 1);
        },
        onRowClicked(item,index) {
            //receive item, index, event
            this.viewItem({index,target:item})
        },
        addProduct(product) {
            //Precisa adicionar no banco de dados e depois adicionar no array
            const index = this.products.findIndex(prod => prod.id == product.id)  
                 
            if (index >= 0) {
                Vue.set(this.products, index, product);
                    
            } else {
                this.products.push(product)
            }
        },
        newProduct() {
            this.productOne = { productName: '', directCosts: [] }
            this.modalTitle="Novo Produto"
            this.$bvModal.show('productModal')
        },
        async viewItem(item){
            //precisa buscar na api o item com os seus directcosts e mandar para o modal
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_ROOT_API}/products/directcosts?id=${item.target.id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                })
                
                this.productOne = data
                
                this.modalTitle="Visualizar Produto"
                this.$bvModal.show('productModal')

            } catch (error) {
                if (error instanceof AxiosError) {
                    const { response } = error
                    console.error(response)
                    if (response.status === 401) {
                        logout()
                    }
                    console.error(error)
                }
            }
        },
        async copyItem(item){
            //precisa buscar na api o item com os seus directcosts e mandar para o modal

            try {
                const { data } = await axios.get(`${process.env.VUE_APP_ROOT_API}/products/directcosts?id=${item.target.id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                })
                
                data.productName = data.productName + " Cópia"
                delete data.id
                this.productOne = data
                this.modalTitle="Visualizar Produto"
                this.$bvModal.show('productModal')
                

            } catch (error) {
                
                if (error instanceof AxiosError) {
                    const { response } = error
                    console.error(response)
                    if (response.status === 401) {
                        logout()
                    }
                    console.error(error)
                }
            }
        },                
        exportTableXLXS() {
            const exportProducts = this.products.map(prod => {
                return {
                    "Nome do Produto": prod.productName,
                    "Custo de Material": prod.materialCost,
                    "Preço de Venda": prod.finalPrice,
                }
            })

            // 1. Crie uma nova planilha
             const worksheet = XLSX.utils.json_to_sheet(exportProducts);

            // 2. Crie um novo workbook
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');

            // 3. Converta o workbook em um arquivo Excel
            const fileName = 'produtos.xlsx';
            XLSX.writeFile(workbook, fileName);
        },
        exportTablePDF() {
            const exportProducts = this.products.map(prod => {
                return {
                    "Nome do Produto": prod.productName,
                    "Custo de Material": prod.materialCost,
                    "Preço de Venda": prod.finalPrice,
                }
            })
            const doc = new jsPDF();

            // 1. Defina a posição inicial para a escrita dos dados
            let yPosition = 10;

            // 2. Adicione um título
            doc.setFontSize(16);
            doc.text('Lista de Produtos', 10, yPosition);
            yPosition += 10;

            // 3. Adicione os cabeçalhos da tabela
            doc.setFontSize(12);
            doc.text('Nome do Produto', 60, yPosition);
            doc.text('Custo de Material', 120, yPosition);
            doc.text('Preço de Venda', 160, yPosition);
            yPosition += 10;

            // 4. Adicione os dados dos produtos
            exportProducts.forEach((product) => {
                doc.text(product['Nome do Produto'], 60, yPosition);
                doc.text(String(product['Custo de Material']), 120, yPosition);
                doc.text(String(product['Preço de Venda']), 160, yPosition);
                yPosition += 10;

                // Verifica se chegou ao final da página
                if (yPosition > 280) {
                doc.addPage();
                yPosition = 10;
                }
            });

            // 5. Salva o PDF com o nome desejado
            doc.save('produtos.pdf');
        },
        handleCostUpdated({ productId, materialCost }) {
            
            const index = this.products.findIndex(p => p.id === productId);
            if (index !== -1) {
                // Atualizar o custo do material
                this.products[index].materialCost = typeof materialCost === 'string' ? parseFloat(materialCost.replace(",",".")) : materialCost;

                // Recalcular o preço de venda (a lógica pode ser a mesma do ProductOne ou adaptada)
                const product = this.products[index];

                const finalPrice = (parseFloat(materialCost) + this.totalVariableCosts + this.totalFixedCosts) * (1 + parseFloat(product.profit));
                
                // Atualizar o preço final no array de produtos
                this.products[index].finalPrice = finalPrice;
            }
        },
    },
    computed:{
        rows (){
            return this.products.length  
        },
        currentItem(){
            return (this.currentPage - 1) * this.perPage
        },
        store(){
            return this.$root.$data.totalVariableCost
        }
    },
    async created(){
        try {
            const { data } = await axios.get(`${process.env.VUE_APP_ROOT_API}/products`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
                        
            this.totalVariableCosts = parseFloat(data.totalVariableCosts)
            this.totalFixedCosts = data.costByHour
            this.profit = parseFloat(data.profit)
            this.products = [...data.products.sort((a,b)=> a.id-b.id)]
            this.productsNoFilter = [...data.products.sort((a,b)=> a.id-b.id)]            
            
            this.products = this.products.map(prod => { 
                const productionHours = (parseFloat(prod.productionHours)/60) || 0                   
                
                const finalPrice = (parseFloat(prod.materialCost) + (parseFloat(this.totalVariableCosts) + parseFloat(this.totalFixedCosts))*productionHours) * (1 + parseFloat(prod.profit))
                                
                return {
                    ...prod,
                    finalPrice
                }
            })
            

            this.productsNoFilter = this.productsNoFilter.map( prod => {                
                const finalPrice = (parseFloat(prod.materialCost) + parseFloat(this.totalVariableCosts) + parseFloat(this.totalFixedCosts)) * (1+parseFloat(prod.profit))
                return {
                    ...prod,
                    finalPrice
                }
            })            
        }
        catch (error) {
            if (error instanceof AxiosError) {
                const {response} = error
                console.error(response)
                if (response.status === 401) {
                    logout()
                }
            }
            console.error(error)
        }
    },
    updated() {
        
    },
    components:{Search, ProductOne, OptionButtons , NavMenu},
}
</script>

<style>

</style>